import { render, staticRenderFns } from "./Avavtar.vue?vue&type=template&id=08c50afa&"
import script from "./Avavtar.vue?vue&type=script&lang=js&"
export * from "./Avavtar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports